<template>
  <div>
    <el-card>
      <el-form ref="form" :model="openForm" :inline="true" size="small" @submit.native.prevent>
        <el-row class="vg_mb_8">
          <el-col :md="8">
            <el-form-item label="样品编号:">
              <el-input v-model="openForm.smpl_no" placeholder="请输入样品编号" clearable></el-input>
            </el-form-item>
          </el-col>
          <el-col :md="8" v-if="activeTab === '开卡'">
            <el-form-item label="卡使用状态:">
              <el-select v-model="openForm.rfid_status" placeholder="请选择" clearable>
                <el-option v-for="item in options" :key="item.value" :label="item.label" :value="item.value"> </el-option>
              </el-select>
            </el-form-item>
          </el-col>
          <el-col :md="8" v-else>
            <el-form-item label="卡使用状态:">
              <el-select v-model="openForm.rework_status" placeholder="请选择" clearable>
                <el-option v-for="item in options2" :key="item" :label="item" :value="item"> </el-option>
              </el-select>
            </el-form-item>
          </el-col>
          <el-col :md="8">
            <el-form-item label="所属部门:">
              <selectSectionType ref="selectSectionType" @selectStatusRow="getStatusVal2" />
            </el-form-item>
          </el-col>
        </el-row>
        <el-row>
          <div class="vg_mb_8">
            <el-button v-if="activeTab === '开卡'" type="primary" size="small" @click="addCard">开卡</el-button>
            <el-button v-if="activeTab === '开卡'" type="danger" size="small" @click="delCard()" :disabled="isDisabled">销卡</el-button>
            <el-button v-if="activeTab === '返工开卡'" type="warning" size="small" @click="dialogVisible2 = true">返工开卡</el-button>
            <el-button v-if="activeTab === '返工开卡'" type="danger" size="small" @click="delReworkRfidItem()" :disabled="isDisabled2"
              >返工销卡</el-button
            >
            <el-button v-if="activeTab === '返工开卡'" type="primary" size="small" @click="dialogVisible = true">返工卡池</el-button>
            <el-button type="primary" @click="searFrom" size="small" class="vg_ml_16" icon="el-icon-search">查询</el-button>
            <el-button type="info" size="small" class="vd_export" icon="el-icon-refresh-right" @click="buttonRefresh()"> 刷新</el-button>
          </div>
        </el-row>
      </el-form>
      <el-tabs v-model="activeTab" type="border-card" @tab-click="tabClick">
        <el-tab-pane label="开卡" name="开卡">
          <el-table
            class="vg_cursor"
            @sort-change="sortChange"
            border
            :data="cardList"
            style="width: 100%"
            @selection-change="handleSelectionChange"
            @cell-dblclick="dblclick"
          >
            <el-table-column type="index" label="序号" align="center"></el-table-column>
            <el-table-column type="selection" align="center"></el-table-column>
            <el-table-column prop="stff_name" label="开卡人"> </el-table-column>
            <el-table-column prop="smpl_no" label="样品编号"> </el-table-column>
            <el-table-column prop="smpl_suffix" label="更改号"> </el-table-column>
            <el-table-column prop="requ_no" label="委托单号"> </el-table-column>
            <el-table-column prop="belo_dept_name" label="所属部门"> </el-table-column>
            <el-table-column prop="rfid_no" label="卡号"> </el-table-column>
            <el-table-column prop="rfid_status" label="卡使用状态" align="center" sortable>
              <template v-slot="scope">
                <el-tag size="small" :type="getRfidType(scope.row.rfid_status)">
                  {{ getRfidStatus(scope.row.rfid_status) }}
                </el-tag>
              </template>
            </el-table-column>
          </el-table>
          <pubPagination :totalPage="total" @changePageSearch="changeSampPageSearch" ref="pubPagination"></pubPagination>
        </el-tab-pane>
        <el-tab-pane label="返工开卡" name="返工开卡">
          <el-table
            class="vg_cursor"
            @sort-change="sortChange"
            border
            :data="reworkCardList"
            style="width: 100%"
            @selection-change="handleSelectionChange2"
          >
            <el-table-column type="index" label="序号" align="center"></el-table-column>
            <el-table-column type="selection" align="center"></el-table-column>
            <el-table-column prop="stff_name" label="开卡人"> </el-table-column>
            <el-table-column prop="smpl_no" label="样品编号"> </el-table-column>
            <el-table-column prop="requ_no" label="委托单号"> </el-table-column>
            <el-table-column prop="belo_dept_name" label="所属部门"> </el-table-column>
            <el-table-column prop="rework_rfid_no" label="卡号"> </el-table-column>
            <el-table-column prop="rework_status" label="卡使用状态" align="center"> </el-table-column>
          </el-table>
          <pubPagination :totalPage="total2" @changePageSearch="changeSampPageSearch2" ref="pubPagination2"></pubPagination>
        </el-tab-pane>
      </el-tabs>
    </el-card>
    <el-dialog :visible.sync="dialogVisible2" title="返工开卡" width="40%">
      <OpenAddRework @close="dialogVisible2 = false"></OpenAddRework>
    </el-dialog>
    <el-dialog @opened="getDialogData" :visible.sync="dialogVisible" title="返工卡池" width="40%" top="0">
      <el-button type="primary" size="small" @click="dialogTableData.push({ destroy_flag: null, rework_rfid_no: null })">新增</el-button>
      <el-button type="danger" size="small" @click="deleteDiaLogRow">删除</el-button>
      <el-button size="small" type="success" @click="saveDialogData">保存</el-button>
      <search-table
        ref="searchTable"
        :need-search="false"
        :need-fixed-height="false"
        :data="c_dialogTableData"
        :tableRowKey="'id'"
        :columns="dialogTableProperties"
        @selection-change="val => (dialogTableSelection = val)"
        :need-pagination="false"
        :columnMove="false"
      />
    </el-dialog>
  </div>
</template>
<script>
import { getNoCatch, post } from '@api/request';
import { reworkRfidAPI, rfidAPI } from '@api/modules/rfid'; //rfid
import pubPagination from '@/components/common/pubPagination';
import selectSectionType from '@/views/component/selectSectionType';
import SearchTable from '@/components/SearchTableV3.vue';
import OpenAddRework from '@/views/OperateManagement/ReadManage/TabChild/openAddRework.vue';
import { keepNumber } from '@assets/js/regExUtil';
import { cloneDeep } from 'lodash';

export default {
  name: 'openCard',
  components: {
    SearchTable,
    pubPagination,
    selectSectionType,
    OpenAddRework
  },
  data() {
    return {
      activeTab: '开卡',
      openForm: {
        page_no: 1,

        smpl_no: null,
        open_sort: null,
        open_field: null,
        rfid_status: null,
        belo_dept_id: null
      },
      page_no2: 1,
      total: 0,
      total2: 0,
      cardList: [],
      reworkCardList: [],
      multipleSelection: [],
      multipleSelection2: [],
      defaultValType: '',
      selectRefuDisabled: false,
      isDyj: true,
      beloDeptId: null,
      options: [
        { value: 0, label: '未使用' },
        { value: 1, label: '已完成' },
        { value: 2, label: '正在使用' }
      ],
      options2: ['未使用', '已完成', '正在使用'],
      dialogVisible: false,
      dialogTableProperties: [
        { prop: 'index', type: 'selection', labelWidth: '50px' },
        { prop: 'index', type: 'index', labelWidth: '50px', label: '序号' },
        {
          label: '卡号',
          prop: 'rework_rfid_no',
          itemType: 'input',
          input: false,
          sortable: false,
          widthAuto: true,
          subItem: {
            type: 'input',
            maxLength: 10,
            disabled: row => !!row.rework_rfid_id,
            input: (val, row) => (row.rework_rfid_no = keepNumber(val))
          }
        }
      ],
      dialogTableData: [],
      dialogTableSelection: [],
      dialogVisible2: false
    };
  },
  watch: {
    $route(to, from) {
      if (from.path === '/open_list') {
        this.getCardList();
      }
    }
  },
  computed: {
    c_dialogTableData() {
      return this.dialogTableData.filter(item => item.destroy_flag !== 1);
    },
    isDisabled() {
      if (this.multipleSelection.length === 0) {
        return true;
      }
      return this.multipleSelection.some(item => item.rfid_status === 1);
    },
    isDisabled2() {
      if (this.multipleSelection2.length === 0) {
        return true;
      }
      return this.multipleSelection2.some(item => item.rework_status !== '正在使用');
    }
  },
  created() {
    this.getDepartment();
    this.getDepartment();
    this.getCardList();
  },
  methods: {
    //判断是否 是DYJ员工
    getDepartment() {
      let userInfo = this.$cookies.get('userInfo');
      if (userInfo.user_name === 'admin') {
        this.openForm.belo_dept_id = null;
        this.isDyj = false;
        return;
      }
      if (userInfo.dept_id === 2 || userInfo.dept_id === 17) {
        this.openForm.belo_dept_id = userInfo.dept_id + '';
        this.beloDeptId = userInfo.dept_id + '';
        this.isDyj = true;
      } else {
        this.openForm.belo_dept_id = null;
        this.isDyj = false;
      }
    },
    getCardList() {
      getNoCatch(rfidAPI.get_rfids, this.openForm).then(({ data }) => {
        this.cardList = data.list;
        this.total = data.total;
      });
    },
    getReworkCardList() {
      let form = cloneDeep(this.openForm);
      form.page_no = this.page_no2;
      reworkRfidAPI.getReworkRfidItemList(form).then(({ data }) => {
        this.reworkCardList = data.list;
        this.total2 = data.total;
      });
    },
    tabClick({ name }) {
      if (name === '开卡') {
        this.getCardList();
      } else if (name === '返工开卡') {
        this.getReworkCardList();
      }
    },
    changeSampPageSearch(val) {
      this.openForm.page_no = val;
      this.getCardList();
    },
    changeSampPageSearch2(val) {
      this.page_no2 = val;
      this.getReworkCardList();
    },
    searFrom() {
      if (this.activeTab === '开卡') {
        this.openForm.page_no = 1;
        this.$refs.pubPagination.currentPage = 1;
        this.getCardList();
      } else if (this.activeTab === '返工开卡') {
        this.page_no2 = 1;
        this.$refs.pubPagination2.currentPage = 1;
        this.getReworkCardList();
      }
    },
    // 刷新
    buttonRefresh() {
      if (!this.isDyj) {
        this.$refs.selectSectionType.value2 = '全部';
      }
      if (this.activeTab === '开卡') {
        this.openForm = {
          page_no: 1,
          smpl_no: null,
          open_sort: null,
          open_field: null,
          rfid_status: null,
          belo_dept_id: this.isDyj ? this.beloDeptId : null
        };

        this.currentPage = 1;
        this.$refs.pubPagination.currentPage = 1;
        this.getCardList();
      } else if (this.activeTab === '返工开卡') {
        this.openForm = {
          page_no: this.openForm.page_no,
          smpl_no: null,
          open_sort: null,
          open_field: null,
          rfid_status: null,
          belo_dept_id: this.isDyj ? this.beloDeptId : null
        };
        this.page_no2 = 1;
        this.$refs.pubPagination2.currentPage = 1;
        this.getReworkCardList();
      }
    },
    addCard() {
      this.jump('open_add');
    },
    delCard() {
      if (this.multipleSelection.length === 0) {
        return this.$message.warning('至少选择一条数据');
      }
      this.$confirm('此操作将永久删除该卡号, 是否继续?', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      })
        .then(() => {
          let rfid_id_list = [];
          for (let i in this.multipleSelection) {
            rfid_id_list.push(this.multipleSelection[i].rfid_id);
          }
          post(rfidAPI.destroy_rfid_by_ids, { rfid_id_list })
            .then(res => {
              if (res.data.code === 1) {
                return this.$message.warning('状态是正在使用或已完成的卡是不可以销卡');
              }
              if (res.data.code !== 0) {
                return this.$message.error(res.data.msg);
              }
              this.$message.success(res.data.msg);
              this.getCardList();
            })
            .catch(res => {});
        })
        .catch(() => {
          this.$message.info('已取消删除');
        });
    },
    handleSelectionChange(val) {
      this.multipleSelection = val;
    },
    handleSelectionChange2(val) {
      this.multipleSelection2 = val;
    },

    dblclick(val) {
      this.jump('open_edit', { rfid_id: val.rfid_id });
    },
    //查询范围
    getStatusVal2(val) {
      this.openForm.belo_dept_id = val;
    },
    //升序 降序
    sortChange(val) {
      if (val.order === 'ascending') {
        this.openForm.open_sort = 'asc';
        this.openForm.open_field = val.prop;
      } else if (val.order === 'descending') {
        this.openForm.open_sort = 'desc';
        this.openForm.open_field = val.prop;
      } else {
        this.openForm.open_sort = '';
        this.openForm.open_field = '';
      }
      this.openForm.page_no = 1;
      this.getCardList();
    },
    //获取卡的状态
    getRfidStatus(status) {
      if (status === 0) {
        return '正在使用';
      } else if (status === 1) {
        return '已完成';
      } else if (status === 2) {
        return '未使用';
      }
    },
    //通过状态改变 tag的颜色
    getRfidType(status) {
      if (status === 0) {
        return '';
      } else if (status === 1) {
        return 'success';
      } else if (status === 2) {
        return 'warning';
      }
    },
    getDialogData() {
      reworkRfidAPI.getReworkRfidList().then(({ data }) => {
        this.dialogTableData = data;
      });
    },
    deleteDiaLogRow(index) {
      reworkRfidAPI.deleteReworkRfid(this.dialogTableSelection).then(() => {
        this.$message.success('删除成功!');
        this.getDialogData();
      });
    },
    saveDialogData() {
      reworkRfidAPI.addReworkRfid(this.dialogTableData).then(res => {
        this.$message.success('保存成功!');
        this.getDialogData();
      });
    },
    // 删除返工RFID项目
    delReworkRfidItem() {
      if (this.multipleSelection2.length === 0) {
        return this.$message.warning('至少选择一条数据');
      }
      this.$confirm('此操作将永久删除该项目, 是否继续?', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(() => {
        reworkRfidAPI.deleteReworkRfidItem(this.multipleSelection2.map(x => x.rework_rfid_item_id)).then(res => {
          this.$message.success('销卡成功!');
          this.getReworkCardList();
        });
      });
    }
  }
};
</script>

<style scoped>
.el-table {
  margin-top: 15px;
}
.vg-ml-15 {
  margin-top: 15px;
}
::v-deep .el-form-item__content {
  margin-left: 0;
}
.vg_ml_32 {
  margin-left: 32px;
}
</style>
